'use client';

import { getEngineMediaKey } from '@/app/lcv/components/sections/spartan/products/engine/utils';
import { SpartanProductEngineMediaPreloaderItem } from '@/app/lcv/components/sections/spartan/products/engine/view/media-preloader/item';
import type { SpartanProductEngineMediaPreloaderProps } from '@/app/lcv/components/sections/spartan/products/engine/view/media-preloader/types';
export const SpartanProductEngineMediaPreloader = ({
  engines,
  enabled,
  priorityIndex,
  readyIndices,
  onEngineReady
}: SpartanProductEngineMediaPreloaderProps) => {
  if (!enabled) return null;
  return engines.map((engine, index) => readyIndices.has(index) ? null : <SpartanProductEngineMediaPreloaderItem key={getEngineMediaKey(engine)} engine={engine} index={index} lowPriority={index !== priorityIndex} onReady={onEngineReady} />);
};